import React, { useRef } from 'react';
import translations from '../lang';
import emailjs from '@emailjs/browser';

  function Contact({ lang }) {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    // 请将以下三个字符串替换为您在 EmailJS 后台获取的真实 ID
    const SERVICE_ID = 'service_awi37bq';
    const TEMPLATE_ID = 'template_3qixcfq';
    const PUBLIC_KEY = 'ZAHshBk7e6w8zwQXU';

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          console.log('Success:', result.text);
          alert(lang === 'zh' ? '邮件发送成功！' : 'Message sent successfully!');
          e.target.reset(); // 发送成功后重置表单
      }, (error) => {
          console.error('Error:', error.text);
          alert(lang === 'zh' ? '发送失败，请稍后再试。' : 'Failed to send, please try again.');
      });
  };

  return (
        <section className="contact-section">
          <h2>{translations.contact.para[lang]}</h2>

          {/* 新增一个 container 包住标题 + 两列 */}
          <div className="contact-flex-container">
            <div className="contact-left">
              {/* 左标题 */}
              <h3>{lang === 'zh' ? '联系方式' : 'Contact'}</h3>
              <div className="contact-info">
                <ul>
                  <li>
                    {lang === 'zh' ? '邮箱' : 'Email'}:{' '}
                    <a
                      href={`mailto:${
                        lang === 'zh'
                          ? 'hanyanghuang0205@gmail.com'
                          : 'huanh81@mcmaster.ca'
                      }`}
                    >
                      {lang === 'zh'
                        ? 'hanyanghuang0205@gmail.com'
                        : 'hanyanghuang0205@gmail.com'}
                    </a>
                  </li>
                  {lang === 'zh' && <li>微信: Hisuii_</li>}
                  <li>
                    {lang === 'zh' ? '电话' : 'Phone'}:{' '}
                    {lang === 'zh' ? '14790238938' : '365-883-1450'}
                  </li>
                  <li>
                    LinkedIn:{' '}
                    <a
                      href="https://www.linkedin.com/in/hanyanghuang"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      linkedin.com/in/hanyanghuang
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="contact-right">
              {/* 右标题 */}
              <h3>{lang === 'zh' ? '家庭住址' : 'Home Address'}</h3>
              <div className="address-map">
                <iframe
                  title="Map of home address"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2905.791099730442!2d-79.86791762436488!3d43.25579977804361!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c9b85232d2b1b%3A0xa5cdf317701edcac!2s121%20King%20St%20E%2C%20Hamilton%2C%20ON%20L8N%201A9%2C%20Canada!5e0!3m2!1sen!2sus!4v1749616359117!5m2!1sen!2sus"
                  width="320"
                  height="320"
                  style={{ border: 0, borderRadius: '8px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
         
          <div className="email-form-container">
            <h3>{lang === 'zh' ? '发送邮件给我' : 'Send Me a Message'}</h3>
            <form ref={form} onSubmit={sendEmail} className="contact-form">
              <div className="form-row">
                <input 
                  type="text" 
                  name="from_name" // 对应 EmailJS 模板中的 {{from_name}}
                  placeholder={lang === 'zh' ? '您的姓名' : 'Full Name'} 
                  required 
                />
                <input 
                  type="email" 
                  name="reply_to" // 对应 EmailJS 模板中的 {{reply_to}}
                  placeholder={lang === 'zh' ? '您的邮箱地址' : 'Your Email'} 
                  required 
                />
              </div>
              <textarea 
                name="message" // 对应 EmailJS 模板中的 {{message}}
                placeholder={lang === 'zh' ? '请输入内容...' : 'How can I help you?'} 
                rows="5" 
                required
              ></textarea>
              <button type="submit" className="form-submit-btn">
                {lang === 'zh' ? '即刻发送' : 'Send Now'}
              </button>
            </form>
          </div>
        </section>

  );
}

export default Contact;
